export default __webpack_public_path__ + "static/media/skins-header-bg1.46ff1146.png";